import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export const getDashboardApi = async (payload = {}) => {
  try {
    const token = sessionStorage.getItem("accessToken");

    const res = await axios.post(
      `${apiBaseUrl}admin/dashboard`,
      { period: payload.period || "all" },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        error?.message ||
        "Unable to load dashboard data.",
    };
  }
};